import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, LayoutDashboard, LogOut } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "@/context/AuthContext";

const PUBLIC_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/#about" },
  { label: "How It Works", to: "/#how" },
  { label: "Plans", to: "/plans" },
];

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const go = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      if (location.pathname !== "/") { navigate("/"); setTimeout(() => scrollTo(to.slice(2)), 120); }
      else scrollTo(to.slice(2));
    } else navigate(to);
  };
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header className="sticky top-0 z-50 glass">
      <div className="vw-container flex items-center justify-between h-16">
        <Logo />
        <nav className="hidden md:flex items-center gap-7">
          {PUBLIC_LINKS.map((l) => (
            <button key={l.label} onClick={() => go(l.to)}
              className="text-sm font-medium text-slate-300 hover:text-white transition-colors"
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
              {l.label}
            </button>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to={user.role === "admin" ? "/admin" : "/dashboard"}
                className="vw-btn-outline !py-2 !px-4 flex items-center gap-2 text-sm" data-testid="nav-dashboard-btn">
                <LayoutDashboard size={16} /> {user.role === "admin" ? "Admin" : "Dashboard"}
              </Link>
              <button onClick={() => { logout(); navigate("/"); }}
                className="text-sm text-slate-400 hover:text-white flex items-center gap-1.5" data-testid="nav-logout-btn">
                <LogOut size={16} /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-semibold text-slate-200 hover:text-white px-3" data-testid="nav-login-btn">Login</Link>
              <Link to="/register" className="vw-btn-primary !py-2 !px-5 text-sm" data-testid="nav-register-btn">Register</Link>
            </>
          )}
        </div>
        <button className="md:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden glass border-t border-slate-800 px-4 py-4 space-y-2">
          {PUBLIC_LINKS.map((l) => (
            <button key={l.label} onClick={() => go(l.to)}
              className="block w-full text-left py-2.5 text-slate-200 font-medium" data-testid={`m-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
              {l.label}
            </button>
          ))}
          <div className="pt-2 border-t border-slate-800 space-y-2">
            {user ? (
              <>
                <button onClick={() => go(user.role === "admin" ? "/admin" : "/dashboard")} className="vw-btn-outline w-full !py-2.5" data-testid="m-nav-dashboard">
                  {user.role === "admin" ? "Admin Panel" : "Dashboard"}
                </button>
                <button onClick={() => { logout(); go("/"); }} className="w-full py-2.5 text-slate-400" data-testid="m-nav-logout">Logout</button>
              </>
            ) : (
              <>
                <button onClick={() => go("/login")} className="vw-btn-outline w-full !py-2.5" data-testid="m-nav-login">Login</button>
                <button onClick={() => go("/register")} className="vw-btn-primary w-full !py-2.5" data-testid="m-nav-register">Register</button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
